import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./app";

const polls = [...document.querySelectorAll('.dds-poll, #dds-poll')]
polls.forEach(el => createRoot(el).render(<App id={el.dataset.id} type={'poll'}/>))